import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MapPage from './pages/MapPage';
import ReceivedNotePage from './pages/ReceivedNotePage';
import TermsOfService from './components/TermsOfService/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import './index.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<MapPage />} />
      <Route path="/m/:memoryId" element={<MapPage />} />
      <Route path="/n/:token" element={<ReceivedNotePage />} />
      <Route path="/n/:token/stop" element={<ReceivedNotePage />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

export default App;
